const CurrencyInput = ({
  register,
  value,
  error,
}: {
  register: any;
  value: any;
  error?: string;
}) => {
  return (
    <div className="flex flex-col">
      <div className="bg-primary-300 text-xl flex flex-row rounded-lg px-4 py-2.5 items-center">
        <span>₹ </span>
        <input
          {...register}
          style={{ width: value?.toString()?.length + "ch" }}
          type="number"
          className="bg-primary-300 text-xl min-w-4"
        ></input>
        <div className="text-[#999999]">{" /month"}</div>
      </div>
      {error && error?.length > 0 && (
        <div className="text-error text-md font-normal">{error}</div>
      )}
    </div>
  );
};
export default CurrencyInput;
